import { Injectable } from '@angular/core';


/// <reference types="google.analytics" />
// import {} from '@types/google.analytics'; 
declare let ga: any;

@Injectable({
  providedIn: 'root'
})
export class GoogleAnalyticsService {

  constructor() { }

  public sendGoogleEvent(eventCategory: string,
                         eventAction: string,
                         eventLabel: string = null,
                         eventValue: number = null)
  {
    ga('send', 'event', 
    {
      eventCategory: eventCategory,
      eventAction: eventAction,
      eventLabel: eventLabel,
      hitType: eventValue      
    });    
  }


}
